


























import {
  defineComponent,
  getCurrentInstance,
  PropType,
  ref,
  useRoute,
  watch,
} from '@nuxtjs/composition-api';

import CashbackImage from '~/components/Cashback/Image.vue';
import { useCashback } from '~/composables';
import { ProductInterface } from '~/modules/GraphQL/types';

import MainCarousel from './Main.vue';
import ZoomCarousel from './Zoom.vue';

export default defineComponent({
  name: 'Gallery',
  components: {
    ZoomCarousel,
    MainCarousel,
    CashbackImage,
  },
  props: {
    product: {
      type: [Object, null] as PropType<ProductInterface | null>,
      default: null,
    },
    images: {
      type: Array,
      required: true,
    },
    sliderOptions: {
      type: Object,
      default: () => ({
        type: 'slider',
        autoplay: false,
        rewind: false,
        perView: 1,
        dragThreshold: 0,
      }),
    },
  },
  setup(props) {
    const route = useRoute();
    const { hasCashback } = useCashback(props.product);

    const isZoomOpen = ref(false);
    const currentSlide = ref(0);

    const toggleZoom = () => {
      isZoomOpen.value = !isZoomOpen.value;
    };
    const openOverlay = (options) => {
      currentSlide.value = options.currentSlide;
      toggleZoom();
    };
    const validateRoute = () => {
      const instance = getCurrentInstance();
      instance?.proxy?.$forceUpdate();
    };
    const onEscapePress = () => {
      if (isZoomOpen.value) {
        toggleZoom();
      }
    };

    watch(route, validateRoute);

    return {
      isZoomOpen,
      currentSlide,
      hasCashback,
      openOverlay,
      onEscapePress,
    };
  },
});
